export const nameFilter = (name) => {
    if (window.environment !== 'bz') {
        return name
    }
    const sourceNames = ['孙宏', '金烨', '余安生', '崔伟', '柳俊权',]
    const targetNames = ['唐丹玲', '黄坤明', '唐丹玲', '陈嘉嘉', '汪欣',]
    const index = sourceNames.indexOf(name)
    if (index > -1) {
        return name.replace(sourceNames[index], targetNames[index])
    }
    return name
}